import { Box, Typography, SwipeableDrawer, TextField } from '@material-ui/core'
import { KeyboardDatePicker } from '@material-ui/pickers'
import styled from 'styled-components'
import { darken } from 'polished'
import { ITextInputProps } from 'pages/content/components/jobs/components/atoms'
import { Button } from 'common/atoms/Button/Button'

export const StyledDrawer = styled(SwipeableDrawer)`
  background-color: ${props => props.theme.colors.supplementary};
  max-width: min-content;
`
export const StyledContentWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  padding: 0 37px;
  width: 397px;
`

export const StyledDateInputWrapper = styled(Box)`
  display: flex;
  gap: 20px;
`

export const StyledDatePicker = styled(KeyboardDatePicker)`
  max-width: 140px;
  padding: 0 !important;
  height: 30px !important;

  && .MuiInputAdornment-positionEnd {
    margin: 0;
  }
`

export const StyledLabel = styled(Typography)<{ fontSize?: string }>`
  color: ${props => props.theme.colors.accent1};
  font-weight: bold !important;
  margin-bottom: 5px !important;
  font-size: ${props => (props.fontSize ? props.fontSize : '1rem')} !important;
`
export const StyledSelectContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 20px !important;
  margin-top: 20px;
  width: auto;
`

export const StyledBox = styled(Box)`
  border-bottom: 1px solid ${props => props.theme.colors.supplementary};
  padding: 15px 0;
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const StyledTextField = styled(TextField)<ITextInputProps>`
  && {
    width: 100%;
  }
  && .MuiInputBase-root {
    background-color: ${props => props.theme.colors.bgPrimary};
    border: 0;
  }
  & .MuiInputBase-root.Mui-disabled {
    color: ${props => darken(0.35, props.theme.colors.accent)} !important;
  }
`

export const TextFieldContainer = styled(Box)`
  background-color: ${({ theme }) => theme.colors.bgPrimary};
  border-radius: 10px;
  border: 2px solid ${({ theme }) => theme.colors.accent1};
  padding: 0 1rem 0.5rem 0;
  overflow: hidden;
  width: 100%;
`
